<template>
    <div class="container py-4">
        <div class="row">
            <div class="col-8">
                <h2 class="mb-4">New app</h2>
                <router-link :to="{name: 'appIndex'}" class="btn btn-outline-dark btn-sm mb-3">All apps</router-link>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="alert alert-success" role="alert" v-if="success">
                    App successfully created!
                </div>
                <div class="card">
                    <div class="card-body">
                        <form @submit.prevent="submit">
                            <div class="form-group">
                                <label for="name">Name*</label>
                                <input class="form-control" id="name" name="name"
                                       placeholder="Enter full name"
                                       type="text"
                                       v-bind:class="[this.name.validated ? this.name.valid ? 'is-valid' : 'is-invalid' : '']"
                                       v-model="form.name"
                                       v-validate="'required'">
                                <div class="invalid-feedback">{{ errors.first('name') }}</div>
                            </div>
                            <div class="form-group">
                                <label for="app_id">App Id*</label>
                                <input class="form-control" id="app_id" name="app_id"
                                       type="text"
                                       v-bind:class="[this.app_id.validated ? this.app_id.valid ? 'is-valid' : 'is-invalid' : '']"
                                       v-model="form.app_id"
                                       v-validate="'required'">
                                <div class="invalid-feedback">{{ errors.first('app_id') }}</div>
                            </div>
                            <div class="form-group">
                                <label for="token">Token*</label>
                                <input class="form-control" id="token" name="token" placeholder="Enter token"
                                       type="text"
                                       v-bind:class="[this.token.validated ? this.token.valid ? 'is-valid' : 'is-invalid' : '']"
                                       v-model="form.token"
                                       v-validate="'required'">
                                <div class="invalid-feedback">{{ errors.first('token') }}</div>
                            </div>
                            <div class="form-group">
                                <label for="podio_url">Podio url</label>
                                <input class="form-control" id="podio_url"
                                       name="podio_url"
                                       placeholder="Enter podio url"
                                       type="text"
                                       v-bind:class="[this.podio_url.validated ? this.podio_url.valid ? 'is-valid' : 'is-invalid' : '']"
                                       v-model="form.podio_url"
                                >
                                <div class="invalid-feedback">{{ errors.first('podio_url') }}</div>
                            </div>
                            <div class="form-group">
                                <label for="order">Order</label>
                                <input class="form-control" id="order"
                                       name="order"
                                       placeholder="Enter order"
                                       type="text"
                                       v-bind:class="[this.order.validated ? this.order.valid ? 'is-valid' : 'is-invalid' : '']"
                                       v-model="form.order"
                                >
                                <div class="invalid-feedback">{{ errors.first('order') }}</div>
                            </div>

                            <button class="btn btn-primary" type="submit">Submit</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapFields} from 'vee-validate'

    export default {
        name: 'appCreate',
        data() {
            return {
                success: false,
                error: '',
                checkbox: true,
                form: {
                    name: '',
                    app_id: '',
                    token: '',
                    podio_url: '',
                    order: '',
                }
            }
        },
        computed: {
            ...mapFields(['name', 'app_id', 'token', 'podio_url', 'order'])
        },
        methods: {
            submit() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.$store.dispatch('SAVE_APP', this.form)
                            .then(() => {
                                this.success = true
                                //Form leegmaken
                                this.form = {}
                                this.$validator.reset()
                            })
                            .catch((error) => {
                                if (error.errors.name) {
                                    this.$validator.errors.add({
                                        field: 'name',
                                        msg: error.errors.name[0]
                                    })
                                    this.fieldsVee.name.valid = false
                                }
                                if (error.errors.app_id) {
                                    this.$validator.errors.add({
                                        field: 'app_id',
                                        msg: error.errors.app_id[0]
                                    })
                                    this.fieldsVee.app_id.valid = false
                                }
                                if (error.errors.token) {
                                    this.$validator.errors.add({
                                        field: 'token',
                                        msg: error.errors.token[0]
                                    })
                                    this.fieldsVee.token.valid = false
                                }


                            })
                    }
                })
            },
        }
    }
</script>
